export function isGiftcardTransaction(transaction: any): boolean {
  return (
    transaction?.transactionType === "gift-card-transactions" ||
    (transaction?.transactionType === "payouts" &&
      transaction?.transaction?.type === "GIFT-CARD")
  );
}

/** Non-utility failed txs (e.g. withdrawals) are shown as pending; gift cards keep real status. */
export function shouldMaskFailedAsPending(transaction: any): boolean {
  return (
    !transaction?.utility &&
    !isGiftcardTransaction(transaction) &&
    transaction?.status?.toLowerCase() === "failed"
  );
}

export function getTransactionStatusClass(transaction: any): string {
  const status = transaction?.status?.toLowerCase() ?? "";

  if (shouldMaskFailedAsPending(transaction)) {
    return "text-[#CB9200] text-[10px] font-bold capitalize";
  }

  if (status === "pending") {
    return "text-[#CB9200] text-[10px] font-bold capitalize";
  }
  if (status === "in progress") {
    return "text-[#60B7F6] text-[10px] font-bold capitalize";
  }
  if (status === "completed" || status === "successful") {
    return "text-[#03C668] text-[10px] font-bold capitalize";
  }
  if (status === "failed" || status === "rejected" || status === "declined") {
    return "text-red-700 text-[10px] font-bold capitalize";
  }

  return "";
}

export function getTransactionStatusLabel(transaction: any): string {
  if (shouldMaskFailedAsPending(transaction)) {
    return "PENDING";
  }
  return transaction?.status ?? "";
}

export function getTransactionStatusColor(status: string = "", transaction?: any): string {
  if (transaction && shouldMaskFailedAsPending(transaction)) {
    return "text-[#CB9200]  ";
  }

  switch (status.toLowerCase()) {
    case "pending":
      return "text-[#CB9200]  ";
    case "in progress":
      return "text-[#60B7F6]  ";
    case "completed":
    case "successful":
      return "text-[#03C668]  ";
    case "failed":
    case "rejected":
    case "declined":
      return "text-red-700  ";
    default:
      return "text-[#03C668]  ";
  }
}
